<template>
  <v-app id="dash">
    <!-- 🔹 TOPBAR -->
    <v-app-bar app dark elevation="0" clipped-left color="blue darken-4">
      <v-app-bar-nav-icon @click.stop="toggleSidebar"></v-app-bar-nav-icon>

      <v-toolbar-title>
        <div class="d-flex align-center">
          <v-img
            alt="labict logo"
            class="shrink"
            contain
            src="@/media/AgroDatari_LOGO_25_colorB.png"
            transition="scale-transition"
            width="150"
            height="60"
          />
        </div>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-icon>mdi-account</v-icon>
      <span class="ml-1 mr-2">{{ user }}</span>

      <v-btn @click="logout" v-if="isLoggedIn" text>
        <v-icon>mdi-power-cycle</v-icon>
      </v-btn>
    </v-app-bar>

    <!-- 🔹 SIDEBAR -->
    <v-navigation-drawer
      v-model="menulateral"
      floating
      app
      clipped
      dark
      color="blue darken-3"
      class="sidebar-transition"
      :style="{ zIndex: '1' }"
    >
      <v-list nav class="d-flex flex-column">

        <!-- Home -->
        <v-list-item
          link
          :to="{ path: '/' }"
          active-class="white--text blue darken-3"
          @click="closeSidebarIfMobile"
        >
          <v-list-item-avatar>
            <v-icon>mdi-home-outline</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <h4 class="font-weight-medium">Home</h4>
          </v-list-item-content>
        </v-list-item>

        <!-- Resultados Generales -->
        <v-list-item
          link
          :to="{ path: '/caracterizacion/' }"
          active-class="white--text blue darken-3"
          @click="closeSidebarIfMobile"
        >
          <v-list-item-avatar>
            <v-icon>mdi-file-plus-outline</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <h4 class="font-weight-medium">Resultados Generales</h4>
          </v-list-item-content>
        </v-list-item>

        <!-- Si es ADMIN → selector de productor -->
        <div v-if="userRole === 'admin'" class="px-4 mt-4">
          <v-select
            label="Productor"
            :items="producersByYear"
            item-value="id"
            item-text="nombre"
            :value="selectedProducer"
            @change="handleAdminProducerChange"
            outlined
          ></v-select>
        </div>

        <!-- Si es PRODUCTOR NORMAL → Ver sus Resultados -->
        <div v-else class="mt-2">
          <v-list-item
            class="px-0"
            link
            :to="getSafeRoute()"
            @click="closeSidebarIfMobile"
            active-class="white--text blue darken-3"
          >
            <v-list-item-avatar>
              <v-icon>mdi-file-outline</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <h4 class="font-weight-medium">Mis Resultados</h4>
            </v-list-item-content>
          </v-list-item>
        </div>

      </v-list>
    </v-navigation-drawer>

    <!-- 🔹 CONTENIDO -->
    <v-main style="background-color:#D5D8DC" id="main-content">
      <v-container fluid transition="fade-transition" id="inside-content">
        <router-view :loading="loading"></router-view>
      </v-container>
    </v-main>

    <!-- 🔹 FOOTER -->
    <v-footer dark app padless style="height: 5vh">
      <span class="white--text ml-2">
        <small>LAB ICT &copy; {{ new Date().getFullYear() }}</small>
      </span>
    </v-footer>

  </v-app>
</template>


<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "Dashboard",

  data: () => ({
    userId: localStorage.getItem("user_id"),
    userRole: localStorage.getItem("user_role"),
    menulateral: true, // Será ajustado en mounted()
    loading: false,
    user: localStorage.getItem("username"),
  }),

  computed: {
    ...mapState(["selectedProducer", "selectedYear"]),
    ...mapGetters([
      "producersByYear",
      "isLoggedIn",
      "availableYears",
      "selectedProducerObj",
    ]),

    isMobile() {
      return window.innerWidth < 1200;
    },
  },

  methods: {
    /** 🔄 Toggle sidebar (funciona en cualquier pantalla) */
    toggleSidebar() {
      this.menulateral = !this.menulateral;
    },

    /** 🔐 Cerrar sidebar solo si es mobile */
    closeSidebarIfMobile() {
      if (this.isMobile) {
        this.menulateral = false;
      }
    },

    /** Obtiene id del productor para el año actual */
    getSelfYearlyProducerId() {
      const userPk = String(this.userId);
      const found = this.producersByYear.find(p => String(p.userPk) === userPk);
      return found ? found.id : null;
    },

    /** Ruta segura del productor */
    getSafeRoute() {
      const id = this.getSelfYearlyProducerId();
      return id ? `/detallesencuesta/${id}` : "/";
    },

    /** Cambio de productor desde admin */
    handleAdminProducerChange(value) {
      this.$store.commit("setSelectedProducer", value);
      this.$router.push(`/detallesencuesta/${value}`);
      this.closeSidebarIfMobile();
    },

    /** Logout */
    logout() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push("/login");
      });
    },
  },

  mounted() {
    // Estado inicial del sidebar según pantalla
    this.menulateral = !this.isMobile;

    // Actualizar al redimensionar
    window.addEventListener("resize", () => {
      if (this.isMobile) {
        this.menulateral = false;
      }
    });
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.handleResponsiveSidebar);
  },
};
</script>


<style scoped>
/* Suavidad al abrir/cerrar sidebar */
.sidebar-transition {
  transition: transform 0.25s ease, opacity 0.25s ease;
}
#dash {
  min-height: 100%;
}
#main-content {
  min-height: 100%;
  padding: 0;
}
#inside-content {
  height: 100%;
  overflow: visible;
}
</style>
